<template>
  <div class="partners-page inner">
    <site-menu theme="dark" class="menu"/>
    <div class="content">
      <img src="@/assets/partners.jpg" />
      <div class="cta">
        <label>Become a CPES Partner</label>
        <router-link to="/contact">Contact Us</router-link>
      </div>
    </div>
    <divider />
  </div>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Divider from '@/components/Divider.vue'

  export default {
    name: 'partners-page',
    components: { SiteMenu, Divider },
  }
</script>
<style lang="scss" scoped>
  .content {
    position: relative;
    padding-top: 20px;
    margin-bottom: -25px;
    img {
      width: 100%;
    }
  }
  label {
    font-size: 50px;
    font-weight: bold;
  }
  a {
    display: block;
    width: 240px;
    font-size: 30px;
    color: #fff;
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;
    background: $color-1;
    padding: 7px;
    border-radius: 15px;
    margin: 30px auto;
  }
  @media (max-width: 500px) {
    img {
      display: none;
    }
    .cta {
      text-align: center;
      margin: 50px 20px;
    }
    label {
      color: $color-2;
    }
  }
  @media (min-width: 501px) {
    .cta {
      position: absolute;
      top: 200px;
      left: 650px;
    }
    label {
      color: #fff;
      text-shadow: 5px 5px 15px #333;
    }
  }
</style>
